<div class="modal-backdrop">
    <div class="modal-dialog">
      <h2 class="modal-title">Upgrade Your Plan</h2>
      <p class="trigger-message">{{ triggerMessage }}</p>
      
      <!-- Conditional content if no upgrade is available -->
      @if (noUpgradeAvailable) {
        <div class="no-upgrade-message">
          <p>
            You have reached the maximum limit of your current plan.
            Unfortunately, there is no higher tier available at this time.
            Please contact support for further assistance.
          </p>
        </div>
      } @else {
        <div class="upgrade-cost">
          Upgrade for an additional <strong>{{ additionalCost | currency }}</strong> per month
        </div>
        <h4 class="benefits-title">With this upgrade you'll get:</h4>
        <ul class="benefits-list">
          @for (feature of upgradeFeatures; track feature) {
            <li>{{ feature }}</li>
          }
        </ul>
      }
      
      <div class="modal-actions">
        @if (noUpgradeAvailable) {
          <button kendoButton (click)="onCancel()">Close</button>
        } @else {
          <button kendoButton themeColor="primary" (click)="onConfirm()">
            Upgrade Now
          </button>
          <button kendoButton (click)="onCancel()">Cancel</button>
        }
      </div>
    </div>
  </div>
  
  